// Reč uz procenat na bedžu sniženja ("31% POPUST").
//
// Jezik prodavnice se bira u /admin/settings/store#payment-tax i čuva kao
// BCP 47 oznaka (sr-RS, sr-Cyrl-RS, en, hr...). Bez podešavanja se
// podrazumeva srpski, kao i default u bazi.
export const discountLabel = (language?: string | null): string => {
  const lang = String(language || 'sr-RS').toLowerCase();
  if (lang.startsWith('sr-cyrl') || lang.startsWith('mk')) return 'ПОПУСТ';
  if (/^(sr|hr|bs|me|sl)\b/.test(lang)) return 'POPUST';
  return 'OFF';
};
